import layout from '@/views/common/layout'
const indexPageChild = [
    {
        path: '/sys',
        component: layout,
        children: [
            {
                path: 'adminResourceList',
                component: () => import('@/views/sys/adminResourceList.vue'),
                name: 'rescource',
                meta: { title: '超级后台菜单管理', icon: '' }
            },
            {
                path: 'adminOrgResourceList',
                component: () => import('@/views/sys/adminOrgResourceList.vue'),
                name: 'orgRescource',
                meta: { title: '云店菜单管理', icon: '' }
            },
            {
                path: 'regionList',
                component: () => import('@/views/sys/regionList.vue'),
                name: 'user',
                meta: { title: '地区管理', icon: '' }
            },
            {
                path: 'adminDictList',
                component: () => import('@/views/sys/adminDictList.vue'),
                name: 'user',
                meta: { title: '字典管理', icon: '' }
            },
            {
                path: 'adminDictTypeList',
                component: () => import('@/views/sys/adminDictTypeList.vue'),
                name: 'user',
                meta: { title: '字典类型管理', icon: '' }
            },
            {
                path: 'adminUserList',
                component: () => import('@/views/sys/adminUserList'),
                name: 'userList',
                meta: { title: '用户列表', icon: '', affix: true }
            },
            {
                path: 'orgNumList',
                component: () => import('@/views/sys/orgNumList'),
                name: 'orgList',
                meta: { title: '组织机构管理', icon: '', affix: true }
            },
            {
                path: 'adminMessageList',
                component: () => import('@/views/sys/adminMessageList'),
                name: 'adminMessageList',
                meta: { title: '消息管理', icon: '', affix: true }
            },
            {
                path: 'adminBrandList',
                component: () => import('@/views/brand/adminBrandList'),
                name: 'adminBrandList',
                meta: { title: '品牌管理', icon: '', affix: true }
            },
            {
                path: 'adminCategoryList',
                component: () => import('@/views/sys/adminCategoryList'),
                name: 'adminCategoryList',
                meta: { title: '分类维护', icon: '', affix: true }
            },
            {
                path: 'editAdminCategory',
                component: () => import('@/views/sys/editAdminCategory'),
                name: 'editAdminCategory',
                meta: { title: '分类编辑', icon: '', affix: true }
            },
            {
                path: 'adminCategoryAttrList',
                component: () => import('@/views/sys/adminCategoryAttrList'),
                name: 'adminCategoryAttrList',
                meta: { title: '分类维护属性', icon: '', affix: true }
            },
            {
                path: 'xcxManagementList',
                component: () => import('@/views/sys/xcxManagementList'),
                name: 'xcxManagementList',
                meta: { title: '小程序分类管理', icon: '', affix: true }
            },
            {
                path: 'appLink',
                component: () => import('@/views/sys/appLinkList'),
                name: 'appLink',
                meta: { title: '小程序跳转链接配置', icon: '', affix: true }
            },
            {
                path: 'dataGeneralization',
                component: () => import('@/views/sys/dataGeneralization.vue'),
                name: 'dataGeneralization',
                meta: { title: '数据概括', icon: '' }
            },
            {
                path: 'adminSupplierList',
                component: () => import('@/views/sys/adminSupplierList'),
                name: 'adminSupplierList',
                meta: { title: '供应商列表', icon: '', affix: true }
            },
            {
                path: 'adminSupplierEdit',
                component: () => import('@/views/sys/adminSupplierEdit'),
                name: 'adminSupplierEdit',
                meta: { title: '供应商编辑', icon: '', affix: true }

            },
            {
                path: 'giftList',
                component: () => import('@/views/sys/giftList.vue'),
                name: 'giftList',
                meta: { title: '赠品', icon: '' }
            },
            {
                path: 'giftDetail',
                component: () => import('@/views/sys/giftDetail.vue'),
                name: 'giftDetail',
                meta: { title: '赠品详情', icon: '', affix: true }
            },
            {
                path: 'sampleList',
                component: () => import('@/views/sys/adminSampleList'),
                name: 'sampleList',
                meta: { title: '样品管理', icon: '', affix: true }
            },

        ]
    }
]

export default indexPageChild



// WEBPACK FOOTER //
// ./src/router/modules/system.js